/**
 * Lar MDX-filene skrevet for MDX 1 se ut som før under MDX 2.
 *
 * - MDX 1 sendte også HTML-tagger skrevet som JSX (<h3>, <ul>, <li> …)
 *   til komponentene i MDXProvider. MDX 2 gjør det bare for markdown.
 *   Pluginen gir taggene et komponentnavn (MDX1_h3), som
 *   src/mdx-shortcodes peker til samme komponent som h3.
 * - MDX 1 gjorde class= om til className=. Uten det får komponentene
 *   ikke klassene, og React advarer.
 * - MDX 2 pakker tekst som står alene inne i en JSX-komponent over flere
 *   linjer inn i <p>. Det gjorde ikke MDX 1, så avsnittet pakkes ut igjen.
 */
const TAGGER = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'li', 'a'];
const JSX = ['mdxJsxFlowElement', 'mdxJsxTextElement'];

const besøk = (node) => {
    if (JSX.includes(node.type)) {
        for (const attr of node.attributes || []) {
            if (attr.type === 'mdxJsxAttribute' && attr.name === 'class') {
                attr.name = 'className';
            }
        }
        if (TAGGER.includes(node.name)) {
            node.name = `MDX1_${node.name}`;
        }
        const barn = node.children || [];
        if (node.type === 'mdxJsxFlowElement' && barn.length === 1 && barn[0].type === 'paragraph') {
            node.children = barn[0].children;
        }
    }
    (node.children || []).forEach(besøk);
};

module.exports = () => (tre) => besøk(tre);
module.exports.TAGGER = TAGGER;
